import { BotEndpointService } from "@/views/reminder/shared/endpoint_services/bot-endpoint-service"

export class BotService {
    constructor () {
        this.botEndpointService = new BotEndpointService()
    }

    async check (userId) {
        return this.botEndpointService.check(userId)
    }
}
